import { useMediaQuery } from "@mantine/hooks";

const useIsPhone = () => useMediaQuery("(max-width: 768px)");

export default useIsPhone;
